export default __webpack_public_path__ + "static/media/a9df93f2d0b45960.c2fb48b05486d2c25fc2c754102fe7c9.svg";